export default __webpack_public_path__ + "static/SRUS P60 - Especification Del Producto y Datos Técnicos-a25e502599df4e00c3348b5b9823099e.pdf";